<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.CONTACTS_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="isLoading()"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>

<div [hidden]="isLoading()">
  <div class="row">
    <div class="c-details col-12 col-md-2 col-lg-1">
      <div class="c-details__action-button u-mt--large">
        <button
          (click)="openCreateModal()"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.BUTTON_ADD | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
      <form class="c-search-form--full">
        <div class="c-input-group">
          <input
            type="text"
            name="search"
            id="input-search"
            [(ngModel)]="dataSource().filter"
            class="c-input c-input--beta"
            placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
            required />

          <input
            *ngIf="!dataSource().filter"
            id="contacts-search"
            type="submit"
            class="c-button c-button--search c-button--search--sm"
            value="Search" />
          <input
            *ngIf="dataSource().filter"
            id="contacts-search-clear"
            (click)="dataSource().filter = ''"
            class="c-button c-button--search c-close-search c-button--search--sm"
            value="Clear" />
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="u-scroll--horizontal">
        <table
          mat-table
          matSort
          [dataSource]="dataSource()"
          class="c-table col-md-4">
          <ng-container matColumnDef="famCode">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="10%">
              <span class="c-table__column-title">{{
                localizationConstants.TECH_COVER_CONTACT_FAM_CODE | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              {{ row.famCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.TECH_COVER_CONTACT_EMAIL | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <span
                *ngIf="!row.isEditing"
                class=""
                >{{ row.email }}</span
              >
              <span *ngIf="row.isEditing">
                <input
                  [ngModel]="row.email"
                  (input)="onEmailInput($event, row)"
                  required
                  email
                  maxLength="200"
                  type="email"
                  class="c-input c-input--gamma" />
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              width="30%">
              <span class="c-table__column-title">{{
                localizationConstants.TECH_COVER_CONTACT_PHONE | translate
              }}</span>
            </th>
            <td
              mat-cell
              *matCellDef="let row">
              <span
                *ngIf="!row.isEditing"
                class=""
                >{{ row.phone }}</span
              >
              <span *ngIf="row.isEditing">
                <input
                  [ngModel]="row.phone"
                  (input)="onPhoneInput($event, row)"
                  maxLength="20"
                  type="text"
                  class="c-input c-input--gamma" />
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="15%"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="action">
              <button
                *ngIf="!row.isEditing"
                type="button"
                class="button--sm button-block"
                (click)="onDeleteContact(row)"
                [disabled]="row.isItemLoading">
                <app-loading-icon *ngIf="row.isItemLoading"></app-loading-icon>
                <span *ngIf="!row.isItemLoading">{{
                  localizationConstants.BUTTON_DELETE | translate
                }}</span>
              </button>
              <button
                *ngIf="row.isEditing"
                type="button"
                class="button--sm button-primary button-block"
                (click)="updateContact(row)"
                [disabled]="row.isItemLoading">
                <app-loading-icon *ngIf="row.isItemLoading"></app-loading-icon>
                <span *ngIf="!row.isItemLoading">{{
                  localizationConstants.BUTTON_SAVE | translate
                }}</span>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef
              width="15%"></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="action">
              <button
                *ngIf="!row.isEditing"
                type="button"
                (click)="row.isEditing = !row.isEditing"
                class="button--sm button-secondary button-block"
                [disabled]="row.isItemLoading">
                {{ localizationConstants.BUTTON_EDIT | translate }}
              </button>
              <button
                *ngIf="row.isEditing"
                type="button"
                (click)="row.isEditing = !row.isEditing"
                class="button--sm button-secondary button-block"
                [disabled]="row.isItemLoading">
                {{ localizationConstants.BUTTON_CANCEL | translate }}
              </button>
            </td>
          </ng-container>

          <tr
            matNoDataRow
            *matNoDataRow>
            <td colspan="12">
              <div class="center">
                {{ localizationConstants.TABLE_NO_RESULTS | translate }}
              </div>
            </td>
          </tr>
          <tr
            mat-header-row
            *matHeaderRowDef="['famCode', 'email', 'phone', 'action1', 'action2']"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['famCode', 'email', 'phone', 'action1', 'action2']"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
